import { render, staticRenderFns } from "./ModalTermCertifie.vue?vue&type=template&id=5afcab7c&"
import script from "./ModalTermCertifie.vue?vue&type=script&lang=js&"
export * from "./ModalTermCertifie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports